module.exports = __webpack_public_path__ + "img/05.96693c72.jpg";